import React from "react";
import cn from "../../lib/classnames";
import styles from "./Spinner.module.css";

type Props = {
    isVisible?: boolean;
    className?: string;
};

export default function Spinner({className, isVisible = false}: Props) {
    return <div className={cn(styles.loader, isVisible ? styles.visible : undefined, className)} />;
}
